import { Links } from './Links'

export const serviceMenuOptions = [{
        name: "Services",
        link: Links.services
    },
    {
        name: "Custom Sofware Development",
        link: Links.customsofware
    },
    {
        name: "Mobile Development",
        link: Links.mobiledevelopment
    },
    {
        name: "Website Development",
        link: Links.websitedevelopment
    },
]